import React, { useState } from 'react';
import { Input, Button } from 'antd';

interface CodeInputStepProps {
  onValidate: (code: string) => void;
  isLoading: boolean;
  resellerName?: string;
  resellerCode?: string;
  resellerLogoUrl?: string;
}

const CodeInputStep: React.FC<CodeInputStepProps> = ({
  onValidate,
  isLoading,
  resellerName,
  resellerCode,
  resellerLogoUrl
}) => {
  const [code, setCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.trim()) {
      onValidate(code.trim().toUpperCase());
    }
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cleaned = e.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    setCode(cleaned);
  };

  return (
    <div className="activation-step">
      <div className="activation-step__content" style={{ alignItems: 'flex-start' }}>
        <p className="activation-step__subtitle" style={{ fontSize: '16px', lineHeight: '24px', textAlign: 'left' }}>
        To get started with TruHu enter the {resellerName} activation code. <br />
        Then create a TruHu account to enjoy good color made easy.
        </p>
        <form onSubmit={handleSubmit} className="activation-step__form" style={{ padding: '0px' }}>
          <div className="code-input-group">
            <Input
              size="large"
              placeholder={`Enter your ${resellerName} activation code`}
              value={code}
              onChange={handleCodeChange}
              className="code-input-coupon"
              maxLength={16}
              disabled={isLoading}
              autoFocus
            />
          </div>

          <Button
            type="primary"
            size="large"
            htmlType="submit"
            loading={isLoading}
            disabled={code.length < 8}
            className="activation-submit-btn" style={{ width: '100%', textDecoration: 'none' }}
          >
            {isLoading ? 'Verifying...' : 'Continue'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default CodeInputStep;
